import React,{useState,useEffect,useRef}from 'react'
import { Modal,message,Form,Input} from 'antd';
import { useBnsBaoZhuangUpdateQuery, useBnsBaoZhuangUpdateSaveMutation} from '../../store/ReactWebSiteApi';
import GetUserDept from '../../cpn/GetUserDept';
import MyEditor from '../../cpn/MyEditor';
import ProductForm from '../../backend/project/ProjectSelect';
import MediaForm from '../media/MediaForm';
function PackageEdit(props) {
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const onCreateEdit = (values) => {
        console.log('Received values of form: ', values);
        setOpen(false);
    };
    const [info,setInfo] = useState({
        bbz_content:''
    }); 
    const {data,isSuccess} = useBnsBaoZhuangUpdateQuery({bbz_id:props.bbz_id},{skip:!open})
    const editForm = useRef()
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){                
                editForm.current.setFieldsValue({
                    bbz_name:data.Result.bbz_name,
                    bbz_dept_id:data.Result.bbz_dept_id,
                    bbz_bg_id:data.Result.bbz_bg_id,
                    bbz_content:data.Result.bbz_content,
                    bbz_type_id:data.Result.bbz_type_id,
                })
                setInfo(prevState=>({...prevState,
                    bbz_name:data.Result.bbz_name,
                    bbz_dept_id:data.Result.bbz_dept_id,
                    bbz_dept_name:data.Result.bbz_dept_name,
                    bbz_bg_id:data.Result.bbz_bg_id,
                    bbz_bg_name:data.Result.bbz_bg_name,
                    bbz_content:data.Result.bbz_content,
                    bbz_type_id:data.Result.bbz_type_id,              
                    bbz_type_name:data.Result.bbz_type_name,              
                }))
            }
        }
    },[data,isSuccess])
    const [goodsEdit] = useBnsBaoZhuangUpdateSaveMutation()
    return (
        <>
            <a onClick={() => {setOpen(true)}}>修改</a>
            <Modal
                width={1000}                        
                open={open}
                title='修改推广方案'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreateEdit(values);
                        })
                        .catch((info) => {
                            // console.log('Validate Failed:', info);
                        });
                    goodsEdit({
                        "bbz_bg_id" : info.bbz_bg_id,
                        "bbz_bg_name" : info.bbz_bg_name,
                        "bbz_uid" : localStorage.getItem('eu_id'),
                        "bbz_uname" : localStorage.getItem('eu_name'),
                        "bbz_content" : info.bbz_content,
                        "bbz_dept_id" : info.bbz_dept_id, 
                        "bbz_dept_name" : info.bbz_dept_name,
                        "bbz_e_id" : localStorage.getItem('e_id'),
                        "bbz_name" : info.bbz_name,
                        "bbz_type_id" : info.bbz_type_id,
                        "bbz_type_name" : info.bbz_type_name,                                 
                        "bbz_id" : props.bbz_id,                                 
                    }).then((res) => {
                        console.log(res); 
                        if (res.data.Status === 'success') {
                            message.success('修改成功！')   
                            setOpen(false)                             
                        }
                        if (res.data.Status === 'fail') {
                            message.error('修改失败！'+res.data.Message)
                        }
                    })
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name="form_client_edit"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3 }}
                    ref={editForm}
                >                    
                    <GetUserDept 
                        label='部门'
                        required
                        wrapperCol={{span:10}} 
                        getUserDept={(e,f) => {
                            setInfo(prevState=>({...prevState,bbz_dept_id:e,bbz_dept_name:f}))
                        }}
                        name='bbz_dept_id'
                    />
                    <ProductForm
                        wrapperCol={{span:10}}
                        required    
                        onChange={(e,f) => {
                            setInfo(prevState=>({...prevState,bbz_bbz_id:e,bbz_bbz_name:f.label}))
                        }}
                        name='bbz_bg_id'
                    />
                    <MediaForm
                        name='bbz_type_id'
                        wrapperCol={{span:10}}
                        required
                        onChange={(e,f) => {
                            setInfo(prevState=>({...prevState,bbz_type_id:e,bbz_type_name:f.label}))
                        }}
                    />                       
                    <Form.Item name="bbz_name" label='标题' wrapperCol={{span:20}} required>
                        <Input 
                            onChange={(e) => {setInfo(prevState=>({...prevState,bbz_name:e.target.value}))}}
                        />
                    </Form.Item> 
                    <Form.Item name="bbz_content" label='正文' wrapperCol={{span:20}}>
                        <MyEditor 
                            onChange={(e) => {setInfo(prevState=>({...prevState,bbz_content:e}))}}
                        />
                    </Form.Item>  
                </Form>
            </Modal>
        </>
    )
}

export default PackageEdit